<template>
  <div class="shopping-check">
    <div class="main-width page-inner" v-loading="loading">
      <div class="page-inner-header">
        <div class="page-inner-title">填写并核对订单信息</div>
      </div>
      <div class="wrap-item">
        <div class="clearfix">
          <div class="float-left item-title">收货地址</div>
          <div class="float-right" v-if="address.locationId" @click="showDialog(address)">
            <span>&nbsp;/&nbsp;</span>
            <a href="javascript:;">修改地址</a>
          </div>
          <div class="float-right" @click="showDialog()">
            <a href="javascript:;">新建地址</a>
          </div>
        </div>
        <div>
          <select v-model="address" class="form-control">
            <option v-for="it in addressInfos" :key="it.createdTime" :value="it">详细地址：{{it.detail}} / 联系人姓名：{{it.linkman}} / 联系人手机号：{{it.mobileNumber}}</option>
          </select>
        </div>
      </div>
      <div class="wrap-item">
        <div class="clearfix">
          <div class="float-left item-title">商品明细</div>
        </div>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th colspan="2">商品名称</th>
              <th style="width:120px">单价(元)</th>
              <th>交付包装</th>
              <th style="width:120px">数量</th>
              <th style="width:150px">小计(元)</th>
            </tr>
          </thead>
          <tbody v-for="group in records" :key="group.brandId" style="border-top:1px">
            <tr class="group-item">
              <td colspan="5" class="border-right-none border-left-none">
                <strong>{{group.brandName}}</strong>
              </td>
              <td class="border-right-none" style="color:#f03">￥{{subtotal(group.brandId) | toMoney}}</td>
            </tr>
            <tr class="item" v-for="it in group.items" :key="it.id">
              <td class="border-right-none" style="width:110px">
                <router-link target="_blank" :to="'/sku/'+it.commodityId">
                  <div class="img-wrap" style="width:82px;height:82px">
                    <img v-if="it.pictureUri" :src="getImgUrl(it.pictureUri)" />
                    <img v-else src="@assets/images/no_image.png" />
                  </div>
                </router-link>
              </td>
              <td class="border-right-none">
                <router-link target="_blank" :to="'/sku/'+it.commodityId">
                  <div>{{it.commodityName}}</div>
                </router-link>
              </td>
              <td class="border-right-none" style="color:#f03">￥{{it.unitPrice | toMoney}}</td>
              <td class="border-right-none">{{it.pkgName}} x {{ it.quantity }}</td>
              <td class="border-right-none">{{it.layQty * it.quantity}}</td>
              <td style="color:#f03">￥{{multiply(it.unitPrice, it.layQty * it.quantity) | toMoney}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="wrap-item">
        <div class="clearfix">
          <div class="float-left item-title">要求到货日期</div>
        </div>
        <div class="wrap-bordered" style="padding:15px 20px">
          <span class="custom-control-inline" style="margin-right:50px;">常规运输时间： 5天</span>
          <span class="custom-control-inline">要求到货日期： 不迟于</span>
          <span class="custom-control-inline">
            <flat-pickr v-model="arrivalDate" class="form-control time" placeholder="请选择日期" :config="{ dateFormat:'Y-m-d',time_24hr:true,minDate:'today' }"></flat-pickr>
          </span>
        </div>
      </div>
      <div class="fees">
        <div class="text-right">
          <span class="custom-control-inline">总商品金额：</span>
          <strong class="money">￥{{total | toMoney}}</strong>
        </div>
        <div class="text-right">
          <span class="custom-control-inline">折扣金额：</span>
          <strong class="money">-￥0.00</strong>
        </div>
        <div class="text-right">
          <span class="custom-control-inline">配送费/运费：</span>
          <strong class="money">￥0.00</strong>
        </div>
        <div class="text-right">
          <span class="custom-control-inline">应付总额：</span>
          <strong class="money">￥{{total | toMoney}}</strong>
        </div>
      </div>
      <div class="clearfix summary">
        <div class="float-right">
          <span>
            应付总额：
            <strong>￥{{total | toMoney}}</strong>
          </span>
          <button class="ap-btn ap-btn-darkred" @click="submitOrder">提交订单</button>
        </div>
      </div>
    </div>

    <Dialog title="新建收货地址" @callback="save" ref="dialog">
      <strong>所在区域</strong>
      <div style="margin:10px 0 20px;display:flex;height:36px;">
        <AutoComplete style="flex:1;" @change="changeProvince" placeholder="省份">
          <option value></option>
          <option v-for="it in provinces" :value="it.sourceId" :key="it.sourceId" :selected="it.sourceId == provinceId">{{it.name}}</option>
        </AutoComplete>
        <AutoComplete style="flex:1;margin: 0 10px;" @change="changeCity" placeholder="市">
          <option value></option>
          <option v-for="it in cities" :value="it.sourceId" :key="it.sourceId" :selected="it.sourceId == cityId">{{it.name}}</option>
        </AutoComplete>
        <AutoComplete style="flex:1;" @change="changeRegion" placeholder="区县">
          <option value></option>
          <option v-for="it in regions" :value="it.id" :key="it.id" :selected="it.id == regionId">{{it.name}}</option>
        </AutoComplete>
      </div>
      <strong>详细地址</strong>
      <div class="clearfix" style="margin:10px 0 20px;">
        <input class="form-control float-left" placeholder="街道，建筑物门牌号" v-model="detail" />
      </div>
      <strong>收货人</strong>
      <div class="clearfix" style="margin:10px 0 20px;">
        <input class="form-control float-left" placeholder="姓名" style="width:140px; margin-right:20px" v-model="linkman" />
        <input type="number" class="form-control float-left" placeholder="手机号码" style="width:305px" v-model="mobileNumber" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import InputNumber from "@components/InputNumber.vue";
import AutoComplete from "@components/AutoComplete.vue";
import Dialog from "@components/Dialog.vue";
import * as localStorage from "@common/localStorage";
import * as utils from "@common/utils";

export default {
  components: {
    InputNumber,
    AutoComplete,
    Dialog
  },
  data() {
    return {
      loading: false, // 下单时的loading
      records: [],
      arrivalDate: "",
      addressInfos: [],
      address: {},
      addrIdx: -1,
      provinces: [], // 新增地址省市区
      provinceId: "",
      cities: [],
      cityId: "",
      regions: [],
      regionId: "",
      detail: "",
      linkman: "",
      mobileNumber: ""
    };
  },
  created() {
    this.records = localStorage.read("cart");
    document.title = "51 AUTOPARTS 填写并核对订单信息";
    this.getOrgPro();
  },
  mounted() {
    this.$refs.dialog.close();
  },
  computed: {
    total() {
      let result = 0;
      this.records.forEach(x =>
        x.items.forEach(y => {
          result += this.multiply(y.unitPrice, y.layQty * y.quantity);
        })
      );
      return result;
    },
    amout() {
      let result = 0;
      this.records.forEach(x =>
        x.items.forEach(y => {
          result += y.layQty * y.quantity;
        })
      );
      return result;
    }
  },
  methods: {
    getOrgPro(args) {
      this.$get("/spms/myProfiles/getOrgProfile/")
        .then(res => {
          this.addressInfos = res.addressInfos.filter(x => "DELIVERY" == x.type);
          if (this.addressInfos.length) {
            if (args == "selectLast") {
              this.address = this.addressInfos[this.addressInfos.length - 1];
            } else {
              this.address = this.addressInfos[0];
            }
          }
        })
        .catch(err => {});
    },
    subtotal(brandId) {
      let brandGroup = this.records.filter(x => x.brandId == brandId);
      let result = 0;
      brandGroup[0].items.forEach(x => {
        result += this.multiply(x.unitPrice, x.layQty * x.quantity);
      });
      return result;
    },
    submitOrder() {
      this.loading = true;
      let cartItems = [];
      this.records.forEach(x => {
        x.items.forEach(y => cartItems.push(y.id));
      });
      let locationIds = this.address.locationPathIndex.split(",");
      let locationNames = this.address.locationShowingName.split(" ");
      let params = {
        cartItems,
        goodsReceivingInfo: {
          linkman: {
            name: this.address.linkman,
            tel: this.address.mobileNumber
          },
          location: {
            province: locationNames[1],
            provinceId: locationIds[1],
            city: locationNames[2],
            cityId: locationIds[2],
            district: locationNames[3],
            districtId: locationIds[3],
            description: this.address.detail
          }
        },
        requirementInfo: {
          arrivalDate: this.arrivalDate && new Date(this.arrivalDate + " 00:00:00").getTime()
        },
        paymentInfo: {
          paymentMode: "OFFLINE"
        },
        invoice: {}
      };
      this.$post("/bhome/carts/generateOrder", params)
        .then(res => {
          this.loading = false;
          this.$router.replace("/shoppingSubmited/" + res.id + "/" + res.orderNumber + "/" + res.totalAmt + "/" + res.paymentModeLiteral);
        })
        .catch(err => (this.loading = false));
    },
    multiply(arg1, arg2) {
      return utils.multiply(arg1, arg2);
    },
    showDialog(item) {
      this.provinceId = "";
      this.provinces = [];
      this.cityId = "";
      this.cities = [];
      this.regionId = "";
      this.regions = [];
      this.addrIdx = -1;
      this.detail = "";
      this.linkman = "";
      this.mobileNumber = "";
      if (item) {
        let locationIds = item.locationPathIndex.split(",");
        this.detail = item.detail;
        this.linkman = item.linkman;
        this.mobileNumber = item.mobileNumber;
        this.changeProvince(locationIds[1]);
        this.changeCity(locationIds[2]);
        this.changeRegion(item.locationId + "_" + item.locationVn);
        this.addrIdx = item.idx;
      }
      this.getProvinces();
      this.$refs.dialog.show();
    },
    save() {
      if (!this.regionId) return $msg.warning("请选择所在区域");
      if (!this.detail) return $msg.warning("请填写详细地址");
      if (!this.linkman) return $msg.warning("请填写收货人姓名");
      if (!this.mobileNumber) return $msg.warning("请填写收货人手机号码");
      let args = {
        type: "DELIVERY",
        detail: this.detail,
        locationId: this.regionId,
        linkman: this.linkman,
        mobileNumber: this.mobileNumber
      };
      if (this.addrIdx >= 0) args.idx = this.addrIdx;
      this.$post("/spms/myProfiles/saveOrgAddr", args)
        .then(res => {
          this.getOrgPro("selectLast");
          this.$refs.dialog.close();
        })
        .catch(err => {});
    },
    getProvinces() {
      if (this.provinces.length) return;
      this.$list("/dmhs/locations/query/")
        .then(res => (this.provinces = res))
        .catch(err => {});
    },
    changeProvince(v) {
      this.provinceId = v;
      this.cityId = "";
      this.regionId = "";
      this.cities = [];
      this.regions = [];
      this.getCities();
    },
    getCities() {
      this.$list("/dmhs/locations/query/", { parentId: this.provinceId })
        .then(res => (this.cities = res))
        .catch(err => {});
    },
    changeCity(v) {
      this.cityId = v;
      this.regionId = "";
      this.regions = [];
      this.getRegions();
    },
    getRegions() {
      this.$list("/dmhs/locations/query/", { parentId: this.cityId })
        .then(res => (this.regions = res))
        .catch(err => {});
    },
    changeRegion(v) {
      this.regionId = v;
    }
  }
};
</script>

<style lang="less">
.shopping-check {
  padding: 12px 0;
  background: #f2f2f2;
  .img-wrap {
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  thead {
    background: #f2f2f2;
    th {
      vertical-align: top;
      border-color: #f2f2f2;
    }
  }
  tr.item {
    &:hover {
      background: #f2f2f2;
      .border-right-none {
        border-right-color: #f2f2f2 !important;
      }
    }
  }
  .wrap-item {
    margin-bottom: 40px;
  }
  .item-title {
    margin-bottom: 10px;
    font-size: 1rem;
    font-weight: bold;
  }
  .group-item {
    td {
      border-bottom: 2px solid #ccc;
    }
  }
  .fees {
    padding-bottom: 40px;
    border-bottom: 2px solid #e4e4e4;
    .money {
      display: inline-block;
      width: 140px;
      color: #f03;
    }
  }
  .summary {
    margin-top: 40px;
    span,
    button {
      display: inline-block;
      vertical-align: middle;
    }
    span {
      margin: 0 30px;
    }
    strong {
      color: #f03;
      font-size: 18px;
    }
    .ap-btn-darkred {
      width: 150px;
      padding: 15px 0;
      font-size: 20px;
      font-weight: bold;
      background: #f03;
      &:hover {
        font-weight: normal;
      }
    }
  }
}
</style>